import React, { useMemo } from 'react';
import { CardActionArea, Paper, Typography } from '@material-ui/core';
import useStyles from './style';

interface Props {
  label: React.ReactNode;
  value: React.ReactNode;
  onClick?: () => void;
  button?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function ({ label, value, className, style, onClick, button }: Props) {
  const classes = useStyles();

  const paperClassName = useMemo(() => {
    let cls = [classes.cartao];
    if (button) cls.push(classes.asButton);
    if (className) cls.push(className);
    return cls.join(' ').trim();
  }, [button, className, classes]);

  if (button) {
    return (
      <Paper className={paperClassName} style={style}>
        <CardActionArea onClick={onClick}>
          <Typography className={classes.value}>{value}</Typography>
          <Typography className={classes.label}>{label}</Typography>
        </CardActionArea>
      </Paper>
    );
  }

  return (
    <Paper className={paperClassName} style={style} onClick={onClick}>
      <Typography className={classes.value}>{value}</Typography>
      <Typography className={classes.label}>{label}</Typography>
    </Paper>
  );
}
